import { Elm } from "./Presidents.elm";

Elm.Presidents.init({ node: document.getElementById("root") });
